import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Wrench, Cog, MessageCircle } from "lucide-react";
import { MAINTENANCE_SERVICES, whatsappLink } from "../data/site";
import { useLang } from "../context/LanguageContext";

const BG = "/images/gallery/fb-jungle-shed.jpg";

export default function Maintenance() {
  const { t } = useLang();
  return (
    <div className="App">
      <Navbar />

      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img src={BG} alt="Motorcycle mechanic" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-gray/95 to-brand-gray/70" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <span className="inline-flex items-center gap-2 text-brand-orange font-heading font-bold uppercase tracking-[0.2em] text-sm">
            <Wrench size={16} /> {t.maintenance.tag}
          </span>
          <h1 className="font-heading font-black text-4xl sm:text-5xl mt-3 max-w-2xl">{t.maintenance.title}</h1>
          <p className="text-white/80 mt-4 max-w-xl">{t.maintenance.subtitle}</p>
          <a
            href={whatsappLink(t.wa.maintenance)}
            target="_blank"
            rel="noreferrer"
            data-testid="maintenance-cta"
            className="inline-flex items-center gap-2 mt-7 bg-brand-orange hover:bg-brand-orange/90 text-white font-heading font-bold py-3 px-7 rounded-full transition-colors"
          >
            <MessageCircle size={18} /> {t.maintenance.cta}
          </a>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-black text-3xl text-brand-gray text-center mb-12">{t.maintenance.pricingTitle}</h2>
          <div className="grid sm:grid-cols-2 gap-6">
            {MAINTENANCE_SERVICES.map((s, i) => (
              <div
                key={i}
                data-testid={`maintenance-item-${i}`}
                className="bg-white border-t-4 border-brand-orange rounded-2xl p-8 shadow-sm hover:-translate-y-1 transition-transform"
              >
                <Cog size={34} className="text-brand-orange mb-4" />
                <h3 className="font-heading font-bold text-xl text-brand-gray">{t.maintenance.services[i].name}</h3>
                <p className="text-slate-500 mt-2 leading-relaxed">{t.maintenance.services[i].desc}</p>
                <div className="mt-6 font-heading font-black text-3xl text-brand-blue">
                  C${s.price} <span className="text-sm text-slate-400 font-body font-normal">{t.common.nio}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
